export const PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME = 'PriceRemoteStickyWrapper-initialPosition';
export const PRICE_REMOTE_STICKY_WRAPPER_SELECTOR = `.${PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME}`;
export const PRICE_REMOTE_FORM_ID = 'price-remote-form';
